import React, { Component, useState } from 'react';
import CustomImage from '../../components/custom-image';

const LeadershipExcellence = () => {
  return (
    <div className="awards-content buttom-section">
      <div className="one-col">
        <h4>Leadership Excellence</h4>
        <div className="table-wrapper">
          <div className="desktop-img">
            <CustomImage
              className="icon-arrow-up"
              imageName="excellence-skilled-talent.png"
              alt="Leadership Excellence"
              maxWidth="895"
            />
          </div>
          <div className="mobile-img">
            <div className="table-img">
              <CustomImage
                className="icon-arrow-up"
                imageName="excellence-skilled-talent-mobile.png"
                alt="Leadership Excellence"
                maxWidth="895"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadershipExcellence;
